(() => {
  const DATE_FORMATTER = new Intl.DateTimeFormat('pt-BR', {
    day: 'numeric',
    month: 'short'
  });

  const addDays = (baseDate, days) => {
    const nextDate = new Date(baseDate);
    nextDate.setDate(nextDate.getDate() + Number(days || 0));
    return nextDate;
  };

  const formatDate = (date) => {
    const compactDate = DATE_FORMATTER.format(date).replace('.', '').trim();
    return compactDate.charAt(0).toUpperCase() + compactDate.slice(1);
  };

  const renderEstimate = (container) => {
    const purchaseLabel = container.dataset.purchaseLabel || 'Compra';
    const shippingLabel = container.dataset.shippingLabel || 'Envio';
    const deliveryLabel = container.dataset.deliveryLabel || 'Entrega';
    const shippingMinDays = Number(container.dataset.shippingMinDays || 1);
    const shippingMaxDays = Number(container.dataset.shippingMaxDays || 2);
    const deliveryMinDays = Number(container.dataset.deliveryMinDays || 10);
    const deliveryMaxDays = Number(container.dataset.deliveryMaxDays || 12);
    const today = new Date();

    const purchaseValue = container.querySelector('[data-delivery-purchase]');
    const shippingValue = container.querySelector('[data-delivery-shipping]');
    const arrivalValue = container.querySelector('[data-delivery-arrival]');
    const purchaseLabelNode = container.querySelector('[data-delivery-purchase-label]');
    const shippingLabelNode = container.querySelector('[data-delivery-shipping-label]');
    const arrivalLabelNode = container.querySelector('[data-delivery-arrival-label]');

    if (purchaseValue) {
      purchaseValue.textContent = formatDate(today);
    }

    if (shippingValue) {
      shippingValue.textContent = `${formatDate(addDays(today, shippingMinDays))} - ${formatDate(addDays(today, shippingMaxDays))}`;
    }

    if (arrivalValue) {
      arrivalValue.textContent = `${formatDate(addDays(today, deliveryMinDays))} - ${formatDate(addDays(today, deliveryMaxDays))}`;
    }

    if (purchaseLabelNode) purchaseLabelNode.textContent = purchaseLabel;
    if (shippingLabelNode) shippingLabelNode.textContent = shippingLabel;
    if (arrivalLabelNode) arrivalLabelNode.textContent = deliveryLabel;
  };

  const init = () => {
    document.querySelectorAll('[data-delivery-estimate]').forEach((container) => {
      renderEstimate(container);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
